import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuthStore } from '@starling/core/auth/store';

/** Передаётся в location.state при редиректе на /login — путь возврата. */
export interface LoginLocationState {
  from?: string;
}

// Гард приватных маршрутов Vision («Моя организация»). Без сессии — редирект
// на /login с сохранением пути возврата (паттерн Light ProtectedRoute).
export function RequireAuth(): JSX.Element {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated());
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname } satisfies LoginLocationState}
      />
    );
  }
  return <Outlet />;
}
